<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <SharedBreadcrumbs :breadcrumbs />

        <FaqSearch />
      </div>

      <h1 class="typography__headline1">Список услуг и&nbsp;их данные</h1>
    </div>

    <div class="page__content">
      <FaqArticlesAside :menu />

      <FaqArticlesContent>
        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="spisok-uslug"
            class="typography__headline2"
          >
            Список услуг
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>В&nbsp;меню слева перейдите в&nbsp;раздел &laquo;Услуги&raquo;.</p>

            <p>
              Сверху справа можно добавить новую услугу или перейти к&nbsp;управлению категориями, нажав соответствующие
              кнопки.
            </p>

            <p>
              В&nbsp;списке есть важная информация об&nbsp;услуге, возможность открыть расписание или заявки, быстро
              скрыть её&nbsp;с&nbsp;сайта или перейти к&nbsp;редактированию, дублированию или удалению.
            </p>

            <p>По&nbsp;нажатию на&nbsp;название услуги перейдем к&nbsp;её&nbsp;странице.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/spisok-uslug-i-ikh-dannye-1.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>Над списком есть сортировка, фильтры и&nbsp;поисковая строка для быстрого поиска нужной услуги.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/spisok-uslug-i-ikh-dannye-2.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="stranica-uslugi"
            class="typography__headline2"
          >
            Страница услуги
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              На&nbsp;открывшейся странице услуги сверху можно увидеть название и&nbsp;тип услуги. Под названием быстрый
              доступ к&nbsp;редактированию, дублированию или удалению.
            </p>

            <p>Ниже находится вся нужная информация об&nbsp;услуге и&nbsp;её&nbsp;галерея.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/spisok-uslug-i-ikh-dannye-3.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            С&nbsp;добавлением услуг и их&nbsp;просмотром разобрались. Самое время перейти к&nbsp;добавлению
            <BaseLink target="_blank" to="/faq/articles/dobavlenie-i-redaktirovanie-zapisi">записи</BaseLink>.
          </p>
        </div>
      </FaqArticlesContent>
    </div>

    <div class="page__related">
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.otherArticles')"
      />

      <FaqArticlesList :articles="relatedArticles" />
    </div>
  </section>

  <LazyFaqArticlesImageModal
    v-if="isModalOpen(MODAL.FaqArticlesImage) && activeImageSource"
    :src="activeImageSource"
    @close="() => (activeImageSource = null)"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { isModalOpen } = useModalStore();
const activeImageSource = ref<null | string>(null);

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/faq",
  },
  {
    name: "Онлайн-&#65279;запись",
    url: "/faq/categories/onlayn-zapis",
  },
  {
    name: "Список услуг и&nbsp;их данные",
  },
];

const menu = [
  {
    name: "Список&nbsp;услуг",
    url: "spisok-uslug",
  },
  {
    name: "Страница&nbsp;услуги",
    url: "stranica-uslugi",
  },
];

const relatedArticles = [
  {
    name: "Настройки записей",
    slug: "nastroyki-zapisey",
  },
  {
    name: "Категории услуг",
    slug: "kategorii-uslug",
  },
  {
    name: "Добавление и&nbsp;редактирование услуги",
    slug: "dobavleniye-i-redaktirovaniye-uslugi",
  },
  {
    name: "Добавление и&nbsp;редактирование записи",
    slug: "dobavlenie-i-redaktirovanie-zapisi",
  },
];

useSeoMeta({
  title: "Список услуг и их данные",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (--xl) {
  .page__content {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: start;
  }
}

.page__related {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}
</style>
